import React, { createContext, useState, useEffect } from 'react';

// Create context
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Get the username string from localStorage
    const savedUser = localStorage.getItem('user');
    return savedUser || null;
  });

  // Function to get full user data when needed
  const getUserData = () => {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  };

  return (
    <UserContext.Provider value={{ user, setUser, getUserData }}>
      {children}
    </UserContext.Provider>
  );
};
